<template>
    <div>
        <div class="tpl-left-nav tpl-left-nav-hover" style="display: block;margin-left: 20px;width: 200px">
            <div class="tpl-left-nav-title">
                栏目
            </div>
            <div class="tpl-left-nav-list">
                <ul class="tpl-left-nav-menu">
                    <div class="tpl-left-nav-split"/>
                    <li class="tpl-left-nav-item" v-for="column in post_column" :key="column['id']" >
                        <a class="nav-link" :class="active_column_id == column.id ? 'router-link-active' : ''" v-if="!column.invisible" @click="change_column(column.id)">
                            <i class="fa"></i>
                            <span>{{column.display_name}}</span>
                        </a>
                    </li>

                </ul>
            </div>
            <!--<div class="tpl-left-nav-title">-->
                <!--快乐生活-->
            <!--</div>-->
            <!--<div class="tpl-left-nav-list">-->
                <!--<ul class="tpl-left-nav-menu">-->
                    <!--&lt;!&ndash;&ndash;&gt;-->
                    <!--<div class="tpl-left-nav-split"/>-->
                    <!--<li class="tpl-left-nav-item" v-for="column in moments_post_column" :key="column['id']">-->
                        <!--<a class="nav-link" :class="active_column_id == column.id ? 'router-link-active' : ''" v-if="!column.invisible" @click="change_column(column.id)">-->
                            <!--<i class="fa"></i>-->
                            <!--<span>{{column.display_name}}</span>-->
                        <!--</a>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        data: function () {
            return {

            }
        },
        computed: {
            ...mapState({
                post_column: state => state.post.post_column,
                active_column_id: state => state.post.active_column_id,
            }),
            ...mapGetters({
                // weblogs_post_column: 'post/weblogs_post_column',
                // moments_post_column: 'post/moments_post_column',
            })
        },
        methods: {
            ...mapActions({
                get_post_column: 'post/get_post_column',
                change_active_column_id: 'post/change_active_column_id',
            }),
            change_column: function (column_id) {
                this.change_active_column_id(column_id)
            }
        },
        mounted() {
            this.get_post_column()
        }
    }
</script>
<style type="text/css" scoped>


</style>
